// extracted by mini-css-extract-plugin
export default {"custom_btn":"theme_custom_btn__5pAAZ"};